import { BrowserClient, } from "@bracket/graphql/clients";
import { getAccount, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getCache, setCache, } from "@bracket/platform/cacheui";
import type { IVaultHasNav, PennyworksPosition, Vault, } from "@bracket/types";


const CACHE_KEY = "pennyworks_positions";


export const getVaultPositions = async ( vault: Vault & IVaultHasNav, ): Promise<PennyworksPosition[]> => {

	if(!vault || !vault.symbol) {
		throw new Error("Vault symbol is required");
	}


	const { symbol, nav, address, } = vault;
	
	type PositionsCacheShapre = {
		[key in typeof symbol]: {
			since: number;
			positions: PennyworksPosition[];
		}
	};

	const now = Math.floor(Date.now() / 1000);
	const params = new URLSearchParams(globalThis.location.search);

	const caching = !(params.get("cache")?.toLowerCase() === "true");
	// const cached: PositionsCacheShapre = (await getCache("pennyworks_positions") || {}) as PositionsCacheShapre;
	
	
	const epoch_duration = 60 * 60 * 24;

	// if(!caching && symbol in cached && now - cached[symbol].since < epoch_duration) {
	// 	return cached[symbol].positions.filter(pos => pos.epoch === nav.epoch);
	// }

	const { address: wallet, } = await getAccount(config);
	const client = BrowserClient.create({ wallet, });
	const result = await client.query("PENNYWORKS_VAULT_POSITIONS", { variables: { vault: symbol, latest: true, }, });

	// await setCache("pennyworks_positions", { ...cached, [symbol]: { since: now, positions: result ?? [], } });
	// globalThis.localStorage.setItem(
	// 	"@bracket:pw_positions_since",
	// 	JSON.stringify({ ...cached, [symbol]: { since: now, positions: result ?? [], } })
	// );

	return result; //.filter(pos => pos.epoch === vault.epoch) ?? [];

};
